export enum EducationType {
  None = 'none',
  InConversationSold = 'in_conversation_sold',
  InConversationTransactionCompleted = 'in_conversation_transaction_completed',
  InMessagesSold = 'in_messages_sold',
  InConversationSoldHAOV = 'in_conversation_sold_haov',
  InConversationTransactionCompletedHAOV = 'in_conversation_transaction_completed_haov',
  InConversationSoldElectronics = 'in_conversation_sold_electronics',
  InConversationSoldElectronicsEvs = 'in_conversation_sold_electronics_evs',
  InConversationTransactionCompletedElectronics = 'in_conversation_transaction_completed_electronics',
  InConversationTransactionCompletedElectronicsEvs = 'in_conversation_transaction_completed_electronics_evs',
}

export enum EducationAction {
  Never = 'never',
  Read = 'read',
  Later = 'later',
  GoToSellerPaymentSettings = 'goto_seller_payment_settings',
  GoToMyItems = 'goto_my_items',
  GoToWallet = 'goto_wallet',
  GoToConversation = 'goto_conversation',
  SetupPaypal = 'setup_paypal',
  SendEmail = 'send_email',
  ConfirmRealName = 'confirm_real_name',
}
